import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import StaffTimesheet from "@/pages/StaffTimesheet";
import StaffHistory from "@/pages/StaffHistory";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminApprovals from "@/pages/AdminApprovals";
import AdminProjects from "@/pages/AdminProjects";
import AdminStaff from "@/pages/AdminStaff";
import AdminReports from "@/pages/AdminReports";

function RoleRedirect() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex items-center justify-center min-h-screen text-sm text-neutral-500">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/staff"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RoleRedirect />} />

          {/* Staff */}
          <Route
            path="/staff"
            element={
              <ProtectedRoute role="staff">
                <Layout>
                  <StaffTimesheet />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute role="staff">
                <Layout>
                  <StaffHistory />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <Layout>
                  <AdminDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/approvals"
            element={
              <ProtectedRoute role="admin">
                <Layout>
                  <AdminApprovals />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute role="admin">
                <Layout>
                  <AdminProjects />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/staff"
            element={
              <ProtectedRoute role="admin">
                <Layout>
                  <AdminStaff />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute role="admin">
                <Layout>
                  <AdminReports />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
